import {
    GET_USERS_BY_ROL,
    UPDATE_USER_BY_ROLE,
    CONF_LOADING,
    ADD_USER_BY_ROLE,
    UPDATE_ROLE,
    GET_ROLES_BY_MODULE
} from "../actions/ConfigurationActions"

const initialState = {
    users: [],
    roles: [],
    loading: true,
    success: false,
    successUser: false,
};

const CalendarReducer = function(state = initialState, action){
    switch (action.type) {
        case CONF_LOADING: {
            return {
              ...state,
              loading: true,
              success: false
            }
        }
        case GET_USERS_BY_ROL: {
            return {
                ...state,
                users: [...action.data],
                loading: false
            }
        }
        case GET_ROLES_BY_MODULE: {
            return {
                ...state,
                roles: [...action.data],
                loading: false,
            }
        }
        case ADD_USER_BY_ROLE: {
            return {
                ...state,
                loading: false,
                successUser: true,
            }
        }
        case UPDATE_ROLE: {
            return {
                ...state,
                loading: false,
                success: true,
            }
        }
        case UPDATE_USER_BY_ROLE: {
            return {
                ...state,
                successUser: true,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default CalendarReducer;
  

